import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { PackingOrder } from './packing-order';
import { PackingOrderProductPack } from './packing-order-product-pack';


export class PackingOrderProduct extends BaseEntity {

  	id              	: number;
	packingOrder  		: PackingOrder ;
	product         	: Product;
	quantity			: number;
	comment         	: string;
	rank				: number;
	
	//Transient
	packingOrderProductPacks : PackingOrderProductPack[];
	assignedQuantity		 : number = 0;

  constructor() {
    super();

  }
}

